'use strict';

import Helper from '../utils/Helper';

const THEME_COLOR_NAMES = ['c', 'c--hover:hover', 'c--hover:focus'];
const BORDER_COLOR_NAMES = ['b', 'b--hover:hover', 'b--hover:focus', 'b--focus:focus'];
const BACKGROUND_COLOR_NAMES = ['bg', 'bg--hover:hover', 'bg--hover:focus', 'bg--focus:focus'];

const darkenColorHex = (hex, percent) => {
	try {
		if (hex.length === 4) {
			hex = `#${Array(3).join(hex[1])}${Array(3).join(hex[2])}${Array(3).join(hex[3])}`;
		}
		const rgb = Helper.hexToRgb(hex);
		if (rgb === null) {
			return rgb;
		}
		let { r, g, b } = rgb;
		r = Math.round(Math.max(0, Math.min((r * ((100 - percent) / 100)), 255)));
		g = Math.round(Math.max(0, Math.min((g * ((100 - percent) / 100)), 255)));
		b = Math.round(Math.max(0, Math.min((b * ((100 - percent) / 100)), 255)));
		r = r.toString(16);
		g = g.toString(16);
		b = b.toString(16);
		if (r.length === 1) r = `0${r}`;
		if (g.length === 1) g = `0${g}`;
		if (b.length === 1) b = `0${b}`;
		return `#${r}${g}${b}`;
	} catch (err) {
		return hex;
	}
};

const ThemeColorBuilder = function (prefix, themeColor, accentColor, id) {
	const buildClassName = (arr, isThemeColor = true, idString) => arr.map((n) => `${idString}.${prefix}-${isThemeColor ? 't' : 'a'}c-${n}`).join(',');
	const build = (arr, content, isThemeColor = true, idString) => `${buildClassName(arr, isThemeColor, idString)}{${content}:${isThemeColor ? themeColor : accentColor}}`;
	const buildThemeColor = (idString) => build(THEME_COLOR_NAMES, 'color', true, idString);
	const buildBorderColor = (idString) => build(BORDER_COLOR_NAMES, 'border-color', true, idString);
	const buildBackgroundColor = (idString) => build(BACKGROUND_COLOR_NAMES, 'background-color', true, idString);

	const buildAccentColor = (idString) => (accentColor !== undefined ? build(THEME_COLOR_NAMES, 'color', false, idString) : '');
	const buildAccentBorderColor = (idString) => (accentColor !== undefined ? build(BORDER_COLOR_NAMES, 'border-color', false, idString) : '');
	const buildAccentBackgroundColor = (idString) => (accentColor !== undefined ? build(BACKGROUND_COLOR_NAMES, 'background-color', false, idString) : '');

	const batchBuild = (idName) => {
		const idString = idName !== undefined ? `${idName} ` : '';
		const darkAccentHex = accentColor !== undefined ? darkenColorHex(accentColor, 16) : '';
		const darkAccentBg = accentColor !== undefined ? `${idString}.ss360-acd-bg--hover:hover,${idString}.ss360-acd-bg--hover:focus{background-color:${darkAccentHex}}` : '';
		const darkAccentBorder = accentColor !== undefined ? `${idString}.ss360-acd-b--hover:hover,${idString}.ss360-acd-b--hover:focus{border-color:${darkAccentHex}}` : '';
		// eslint-disable-next-line max-len
		return `${buildThemeColor(idString)}${buildBorderColor(idString)}${buildBackgroundColor(idString)}${buildAccentColor(idString)}${buildAccentBorderColor(idString)}${buildAccentBackgroundColor(idString)}${darkAccentBg}${darkAccentBorder}`;
	};

	this.build = () => `${batchBuild()}${batchBuild(id)}`;
};

export default ThemeColorBuilder;